var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"guarantor--wrapper--bg"},[(_vm.isLoading)?_c('LockLoader',{attrs:{"text":_vm.loadingMessage,"asset":"logo-alt.svg"}}):_c('div',{staticClass:"guarantor--wrapper"},[_c('div',{staticClass:"logo"},[_c('Asset',{attrs:{"name":"logo.svg","alt":"Logo Parcelex","title":"Logo Parcelex"}})],1),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }